import { Component, OnInit, ViewChild, Inject, ElementRef, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { BasicInformationService } from "../services/basic-information.service";
import { BasicInformation } from "../models/basicInformation";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { QuestionAndAnswer } from "../models/questionsAndAnswers";
import { MatStepper } from "@angular/material/stepper";
import { DeleteBasicInformation } from "../models/deleteBasicInformation";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddFaqComponent } from "../add-faq/add-faq.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { environment } from "../../environments/environment";
import { UserRoleUserOperation } from "../core/constant";
import { CryptographyService } from "../services/cryptography.service";

@Component({
  selector: "app-faq-module",
  templateUrl: "./faq-module.component.html",
  styleUrls: ["./faq-module.component.scss"],
})
export class FaqModuleComponent implements OnInit {
  loading: boolean = false;
  currentPageRecords: BasicInformation[] = [];
  selectedTopic: BasicInformation = null;
  expandedQuestionIndex: number = 0;
  postData: BasicInformation;
  activePopupId: number | null = null;

  canAddFaq: boolean;
  canDeleteFaq: boolean;
  canEditFaq: boolean;

  constructor(
    private basicInformationService: BasicInformationService,
    public fb: FormBuilder,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private ngbModal: NgbModal,
    private cryptographyService: CryptographyService,
    private router: Router,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.cryptographyService.decryptData(
        this.storage.get("userRoleUserOperation")
      );
      this.canAddFaq =
        userRoleUserOperation.indexOf(UserRoleUserOperation.CanAddFaq) !== -1;
      this.canEditFaq =
        userRoleUserOperation.indexOf(UserRoleUserOperation.CanEditFaq) !== -1;
      this.canDeleteFaq =
        userRoleUserOperation.indexOf(UserRoleUserOperation.CanDeleteFaq) !==
        -1;
    } else {
      this.canAddFaq = true;
      this.canEditFaq = true;
      this.canDeleteFaq = true;
    }
    this.getAllBasicInformation();
  }

  selectTopic(topic: BasicInformation) {
    this.selectedTopic = topic;
    this.expandedQuestionIndex = 0;

    const index = this.currentPageRecords.indexOf(topic);
    if (index > 0) {
      this.currentPageRecords.splice(index, 1);
      this.currentPageRecords.unshift(topic);
    }

    this.elementRef.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  togglePopup(event: Event, topic: BasicInformation) {
    event.stopPropagation();
    this.activePopupId = this.activePopupId === topic.id ? null : topic.id;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".topic-actions")) {
      this.activePopupId = null;
    }
  }

  toggleQuestion(index: number) {
    if (this.expandedQuestionIndex === index) {
      this.expandedQuestionIndex = -1;
    } else {
      this.expandedQuestionIndex = index;
    }
  }

  getFormattedHashtags(item: QuestionAndAnswer): string[] {
    if (item.hashtags && item.hashtags.length > 0) {
      return item.hashtags.map((h) =>
        h.name.startsWith("#") ? h.name : `#${h.name}`
      );
    }
    if (item.hashtag) {
      return item.hashtag
        .split(/[\s,]+/)
        .map((t) => t.trim())
        .filter((t) => t.length > 0)
        .map((t) => (t.startsWith("#") ? t : `#${t}`));
    }
    return [];
  }

  openAddEditQuestionsModal(id?: number) {
    this.activePopupId = null;
    if (id) {
      this.router.navigate(["/add-faq", id]);
    } else {
      this.router.navigate(["/add-faq"]);
    }
  }

  getBasicInformation(id: number) {
    return this.basicInformationService.getBasicInformation(id);
  }

  getAllBasicInformation() {
    this.loading = true;
    this.basicInformationService
      .getAllBasicInformation()
      .subscribe((data: BasicInformation[]) => {
        this.currentPageRecords = (data || []).map((o) => new BasicInformation(o));
        if (this.currentPageRecords && this.currentPageRecords.length > 0) {
          if (this.selectedTopic) {
            const found = this.currentPageRecords.find(
              (t) => t.id === this.selectedTopic.id
            );
            this.selectedTopic = found || this.currentPageRecords[0];
          } else {
            this.selectedTopic = this.currentPageRecords[0];
          }
        } else {
          this.selectedTopic = null;
        }
        this.loading = false;
      });
  }

  openDeletePopup(item: BasicInformation, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.activePopupId = null;
    this.postData = item;

    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title = "Do you want to delete this FAQ?";
    modalRef.componentInstance.deleteItem = item;

    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem: any) => {
      if (deleteItem) {
        this.deleteFAQ();
      }
    });
  }

  deleteFAQ() {
    var deleteBasicInfo = new DeleteBasicInformation();
    deleteBasicInfo.id = this.postData.id;
    deleteBasicInfo.isInfoSetDeleted = true;
    this.basicInformationService
      .updateBasicInformation(deleteBasicInfo)
      .subscribe(() => {
        this.ngbModal.dismissAll();
        this.getAllBasicInformation();
      });
  }
}

